var MDB = window.MDB || {};
MDB.GDPR = MDB.GDPR || {};
MDB.GDPR.Sites = MDB.GDPR.Sites || {};

$.extend(MDB.GDPR.Sites, {
    bindPromptButtons: function (selector) {
        $(selector).on('click', function (e) {
            e.preventDefault();
            var me = this;
            var $me = $(me);

            MDB.navigateAfterPrompt({
                title: $me.data('title'),
                textBody: $me.data('body'),
                url: me.href
            })
        })
    }
});